import { get_rem14pbkv8p42gid as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Icon1h1pe6893iwt2 as Icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_editIcon() {
  _init_properties_extra_icons_kt__ipgcuj();
  return editIcon;
}
var editIcon;
var properties_initialized_extra_icons_kt_31s7yl;
function _init_properties_extra_icons_kt__ipgcuj() {
  if (!properties_initialized_extra_icons_kt_31s7yl) {
    properties_initialized_extra_icons_kt_31s7yl = true;
    editIcon = new (Icon())(get_rem(1.0), get_rem(1.0), 0, -960, 960, 960, listOf('M180-180h44l472-471-44-44-472 471v44Zm-60 60v-128l575-574q8-8 19-12.5t23-4.5q11 0 22 4.5t20 12.5l44 44q9 9 13 20t4 22q0 11-4.5 22.5T823-694L248-120H120Zm659-617-41-41 41 41Zm-105 64-22-22 44 44-22-22Z'));
  }
}
//region block: exports
export {
  get_editIcon as get_editIconv23ytngmqu3s,
};
//endregion

//# sourceMappingURL=extra-icons.mjs.map
